import type { groups as groupContracts } from '@personal-blog/contracts';
import type { TFunction } from 'i18next';

export const EVERYONE_GROUP_ID = '00000000-0000-0000-0000-000000000001' as const;
export const SELF_GROUP_ID = '00000000-0000-0000-0000-000000000002' as const;

export const SYSTEM_GROUP_IDS: ReadonlySet<string> = new Set([
  EVERYONE_GROUP_ID,
  SELF_GROUP_ID,
]);

export function isSystemGroupId(groupId: string): boolean {
  return SYSTEM_GROUP_IDS.has(groupId);
}

export function isEveryoneGroupId(groupId: string): boolean {
  return groupId === EVERYONE_GROUP_ID;
}

export function localiseSystemGroup(
  group: groupContracts.Group,
  t: TFunction,
): groupContracts.Group {
  if (!isEveryoneGroupId(group.id)) return group;
  return {
    ...group,
    name: t('systemGroups.everyone.name'),
    description: t('systemGroups.everyone.description'),
  };
}

export function localiseSystemGroupName(
  group: { readonly id: string; readonly name: string },
  t: TFunction,
): string {
  return isEveryoneGroupId(group.id) ? t('systemGroups.everyone.name') : group.name;
}
